import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgAppListHeaderService, IMetricsExecutionsSummary } from "../ng-app-list-header.service";
import { INgBarGraphValue } from "../../../ng-shared/ng-components/ng-bar-graph/ng-bar-graph.component";
import { displayBigNumber } from "../../../ng-shared/ng-util/tools";
import { Subscription } from "rxjs";

@Component({
    selector: "ng-app-list-tenant-summary",
    templateUrl: "./ng-app-list-tenant-summary.component.html",
    styleUrls: ["./ng-app-list-tenant-summary.component.less"]
})
export class NgAppListTenantSummaryComponent implements OnInit, OnDestroy {

    tenantStatuses: {
        type: string, appTotal: number, instanceTotal: number,
        executionSuccessTotal: number, executionTotal: number, percentage?: number
    }[];
    data: IMetricsExecutionsSummary[];
    total: { apps: number, instances: number, successCount: number, failedCount: number };
    barInputs: INgBarGraphValue[][] = [];
    totalBarInputs: INgBarGraphValue[] = [];

    // Store pretty values
    formValues: string[] = [];
    totalFormValue: string;

    private subscriptions: Subscription[] = [];

    constructor(private headerService: NgAppListHeaderService) {
        this.subscriptions.push(
            this.headerService.getTenantSummaryDataSubject()
                .subscribe(res => {
                    this.data = res;
                    this.setFormValues();
                    this.totalCalculations(res);
                    this.setBarInputs();
                })
        );
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.cleanSubscriptions();
    }

    private cleanSubscriptions() {
        this.subscriptions.forEach(s => {
            try {
                s.unsubscribe();
            } catch (e) { }
        });
    }

    private setFormValues() {
        this.formValues = this.data.map(d => displayBigNumber(d.successCount + d.failedCount));
    }

    private totalCalculations(data: IMetricsExecutionsSummary[]) {
        this.total = {
            apps: 0,
            instances: 0,
            successCount: 0,
            failedCount: 0
        };

        data.forEach(d => {
            this.total.apps += d.appCount;
            this.total.instances += d.instancesCount;
            this.total.successCount += d.successCount;
            this.total.failedCount += d.failedCount;
        });

        this.totalBarInputs = this.getBarInput(this.total as any);
        this.totalFormValue = displayBigNumber(this.total.successCount + this.total.failedCount);
    }

    private setBarInputs() {
        this.barInputs = [];
        this.barInputs = this.data.map(d => this.getBarInput(d));
    }

    private getBarInput(data: IMetricsExecutionsSummary): INgBarGraphValue[] {
        const values: INgBarGraphValue[] = [];
        values.push({ label: "Successful", unit: "", value: data.successCount, bgColor: "#0f9145" });
        values.push({ label: "Faulted", unit: "", value: data.failedCount, bgColor: "#db1d00" });
        return values;
    }
}
